








































































































































































































































































import _ from "lodash";
import { Component, Vue, Watch } from "vue-property-decorator";
import {Getter} from "vuex-class";
import Owner from "@/model/cospirit-api/Owner";
import { Type } from "@/modules/request/Type";
import { AllocationType } from "@/modules/budget/AllocationType";
import { BudgetAllocation } from "@/modules/budget/BudgetAllocation";
import { Budget } from "@/modules/budget/Budget";
import TypeRepository from "@/repositories/request/TypeRepository";
import BudgetAllocationRepository from "@/repositories/budget/BudgetAllocationRepository";
import BudgetRepository from "@/repositories/budget/BudgetRepository";
import AllocationTypeRepository from "@/repositories/budget/AllocationTypeRepository";

export interface BudgetEdit {
    label: string;
    beginDate: string;
    endDate: string;
    amount: number;
    amountIncludingTax: number;
    owner: { uuid: string };
    uuid: string;
}

const components = {
};

@Component({ components })
export default class AdminTitle extends Vue {
    protected activeName: string = "budgetAllocationTab";
    private newType: string = "";
    private modalTypeVisible: boolean = false;
    private typeUuid: string = "";
    private newAllocationType: string = "";
    private modalAllocationTypeVisible: boolean = false;
    private allocationTypeUuid: string = "";
    private newBudget: string = "";
    private modalBudgetVisible: boolean = false;
    private budgetUuid: string = "";
    private newBudgetAllocation: string = "";
    private modalBudgetAllocationVisible: boolean = false;
    private budgetAllocationUuid: string = "";
    private allocationTypes = [];

    private type: Type = {
        label: "",
        uuid: "",
        code: "",
        owner: {
            uuid: ""
        }
    };

    private allocationType = {
        label: "",
        owner: {
            uuid: ""
        },
        uuid: ""
    };

    private budget: BudgetEdit = {
        label: "",
        beginDate: "",
        endDate: "",
        amount: 0,
        amountIncludingTax: 0,
        owner: {
            uuid: ""
        },
        uuid: ""
    };

    private budgetAllocation = {
        uuid: "",
        label: "",
        allocationType: {
            uuid: ""
        },
        budget: {
            uuid: ""
        },
    };

    @Getter("getCurrentOwnerUuid") public ownerUuid!: string;
    @Getter("getTypes") public types!: () => Type[];
    @Getter("getBudgets") public budgets!: () => Budget[];
    @Getter("getOwners") public owners!: () => Owner[];
    @Getter("getBudgetAllocations") public budgetAllocations!: () => BudgetAllocation[];

    @Watch("ownerUuid") private updateOwner() {
        this.type.owner.uuid = this.ownerUuid;
        this.allocationType.owner.uuid = this.ownerUuid;
        this.budget.owner.uuid = this.ownerUuid;
        this.budgetAllocation.allocationType.uuid = this.allocationTypeUuid;
        this.budgetAllocation.budget.uuid = this.budgetUuid;
        this.loadAllocationTypes();
    }

    public mounted(): void {
        this.type.owner.uuid = this.ownerUuid;
        this.allocationType.owner.uuid = this.ownerUuid;
        this.budget.owner.uuid = this.ownerUuid;
        this.budgetAllocation.allocationType.uuid = this.allocationTypeUuid;
        this.budgetAllocation.budget.uuid = this.budgetUuid;
        if (this.ownerUuid) {
            this.loadAllocationTypes();
        }
    }

    private loadAllocationTypes(): void {
        const params = {
            filters: {
                ownerUuid: this.ownerUuid,
                editJoin: true,
            },
            fields: [
                "uuid",
                "label",
                "owner.uuid",
            ],
        };
        AllocationTypeRepository.get(params).then((data: object) => {
            this.allocationTypes = data as any;
        });
    }
    private addType(): void {
        this.type.label = "";
        this.type.uuid = "";
        this.type.code = "";
        this.modalTypeVisible = true;
    }

    private saveType(): void {
        if (this.type.uuid === "") {
            _.unset(this.type, "uuid");
        }
        TypeRepository.save(this.type).then(() => {
            this.$store.dispatch("loadTypes");
            this.modalTypeVisible = false;
            this.newType = "";
        });
    }

    private editType(type: Type): void {
        this.modalTypeVisible = true;
        this.type.uuid = type.uuid;
        this.type.label = type.label;
        this.type.code = type.code;
    }

    private cancelEditType(): void {
        this.newType = "";
        this.typeUuid = "";
        this.modalTypeVisible = false;
    }

    private deleteType(typeUuid: string): void {
        this.$confirm(_.invoke(this.$options.filters, "trans", "deleteTitleConfirmation"))
            .then(() => {
                TypeRepository.delete({ uuid: typeUuid }).then(() => {
                    this.$store.dispatch("loadTypes");
                });
            })
            .catch(() => 0)
        ;
    }

    private addAllocationType(): void {
        this.allocationType.label = "";
        this.allocationType.uuid = "";
        this.modalAllocationTypeVisible = true;
    }

    private saveAllocationType(): void {
        if (this.allocationType.uuid === "") {
            _.unset(this.allocationType, "uuid");
        }
        AllocationTypeRepository.save(this.allocationType).then(() => {
            this.loadAllocationTypes();
            this.$store.dispatch("loadAllocationTypes");
            this.modalAllocationTypeVisible = false;
            this.newAllocationType = "";
        });
    }

    private editAllocationType(allocationType: AllocationType): void {
        this.modalAllocationTypeVisible = true;
        this.allocationType.uuid = allocationType.uuid;
        this.allocationType.label = allocationType.label;
    }

    private cancelEditAllocationType(): void {
        this.newAllocationType = "";
        this.allocationTypeUuid = "";
        this.modalAllocationTypeVisible = false;
    }

    private deleteAllocationType(allocationTypeUuid: string): void {
        this.$confirm(_.invoke(this.$options.filters, "trans", "deleteTitleConfirmation"))
            .then(() => {
                AllocationTypeRepository.delete({ uuid: allocationTypeUuid }).then(() => {
                    this.$store.dispatch("loadAllocationTypes");
                });
            })
            .catch(() => 0)
        ;
    }

    private addBudget(): void {
        this.budget.uuid = "";
        this.budget.label = "";
        this.budget.beginDate = "";
        this.budget.endDate = "";
        this.budget.amount = 0;
        this.budget.amountIncludingTax = 0;
        this.modalBudgetVisible = true;
    }

    private saveBudget(): void {
        this.budget.amount = (this.budget.amount);
        this.budget.amountIncludingTax = (this.budget.amountIncludingTax);
        if (this.budget.uuid === "") {
            _.unset(this.budget, "uuid");
        }
        BudgetRepository.save(this.budget).then(() => {
            this.$store.dispatch("loadBudgets");
            this.modalBudgetVisible = false;
            this.newBudget = "";
        });
    }

    private editBudget(budget: Budget): void {
        this.modalBudgetVisible = true;
        this.budget.uuid = budget.uuid;
        this.budget.label = budget.label;
        this.budget.beginDate = budget.beginDate;
        this.budget.endDate = budget.endDate;
        this.budget.amount = budget.amount;
        this.budget.amountIncludingTax = budget.amountIncludingTax;
    }

    private cancelEditBudget(): void {
        this.newBudget = "";
        this.budgetUuid = "";
        this.modalBudgetVisible = false;
    }

    private deleteBudget(budgetUuid: string): void {
        this.$confirm(_.invoke(this.$options.filters, "trans", "deleteTitleConfirmation"))
            .then(() => {
                BudgetRepository.delete({ uuid: budgetUuid }).then(() => {
                    this.$store.dispatch("loadBudgets");
                });
            })
            .catch(() => 0)
        ;
    }

    private addBudgetAllocation(): void {
        this.budgetAllocation.label = "";
        this.budgetAllocation.uuid = "";
        this.modalBudgetAllocationVisible = true;
    }

    private saveBudgetAllocation(): void {
        if (this.budgetAllocation.uuid === "") {
            _.unset(this.budgetAllocation, "uuid");
        }
        BudgetAllocationRepository.save(this.budgetAllocation).then(() => {
            this.$store.dispatch("loadBudgetAllocations");
            this.modalBudgetAllocationVisible = false;
            this.newBudgetAllocation = "";
        });
    }

    private editBudgetAllocation(
        budgetAllocation: BudgetAllocation,
        allocationType: AllocationType,
        budget: Budget
    ): void {
        this.modalBudgetAllocationVisible = true;
        this.budgetAllocation.uuid = budgetAllocation.uuid;
        this.budgetAllocation.label = budgetAllocation.label;
        this.budgetAllocation.allocationType.uuid = allocationType.uuid;
        this.budgetAllocation.budget.uuid = budget.uuid;
    }

    private cancelEditBudgetAllocation(): void {
        this.newBudgetAllocation = "";
        this.budgetAllocationUuid = "";
        this.modalBudgetAllocationVisible = false;
    }

    private deleteBudgetAllocation(budgetAllocationUuid: string): void {
        this.$confirm(_.invoke(this.$options.filters, "trans", "deleteTitleConfirmation"))
            .then(() => {
                BudgetAllocationRepository.delete({ uuid: budgetAllocationUuid }).then(() => {
                    this.$store.dispatch("loadBudgetAllocations");
                });
            })
            .catch(() => 0)
        ;
    }

    public getAllocationTypeLabel(uuid: string) {
        const allocationType = _.find(this.allocationTypes, (alloc: AllocationType) => {
            return alloc.uuid === uuid;
        });

        return _.get(allocationType, "label", "");
    }

    public getBudgetLabel(uuid: string) {
        const budget = _.find(this.budgets, (budgetObj: Budget) => {
            return budgetObj.uuid === uuid;
        });

        return _.get(budget, "label", "");
    }

    public getOwner(uuid: string) {
        return _.find(this.owners, (owner: Owner) => {
            return owner.uuid === uuid;
        });
    }

    public orderOwnersAsc(owners: Owner[]) {
        return _.orderBy(owners, ["fullName"], ["asc"]);
    }
}
